export class RabiesVaccinationModel {
    history_sequence: number
    brief_hist_sequence: number
    pet_no: number
    doctor_initials: string
    bln_3yr: boolean

    constructor(
        history_sequence: number,
        brief_hist_sequence: number,
        pet_no: number,
        doctor_initials: string,
        bln_3yr: boolean
    ) {
        this.history_sequence = history_sequence
        this.brief_hist_sequence = brief_hist_sequence
        this.pet_no = pet_no
        this.doctor_initials = doctor_initials
        this.bln_3yr = bln_3yr
    }
}